import { render, staticRenderFns } from "./DatatableColumns.vue?vue&type=template&id=46039632&scoped=true&"
import script from "./DatatableColumns.vue?vue&type=script&lang=js&"
export * from "./DatatableColumns.vue?vue&type=script&lang=js&"
import style0 from "./DatatableColumns.vue?vue&type=style&index=0&id=46039632&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46039632",
  null
  
)

export default component.exports